module.exports = __webpack_public_path__ + "img/img5.0579e690.svg";